﻿import modularConfigurator from '../modules/modular-configurator/modular-configurator-form.js';
import modularConfiguratorDatalayer from '../modules/datalayer/pages/modular-configurator-datalayer.js';
import configuratorResizer from '../modules/configurator/configurator-resizer.js';

function initConfigurator() {
    const container = document.querySelector('#configurator-container');
    const form = document.querySelector('#configurator-form');

    if (container && modularConfigurator.canInit('#configurator-container')) {
        modularConfigurator.init();
    }

    if (form && modularConfigurator.canInitForm('#configurator-form')) {
        modularConfigurator.initForm();
    }

    modularConfiguratorDatalayer.init();
    configuratorResizer.init('#configurator-container');
}

initConfigurator();